import React from "react";
import Image from "next/image";
import webBanner from "../public/images/page_banner/location_desk.jpg";
import mobBanner from "../public/images/page_banner/location_mob.jpg";
import { Col, Container, Row } from "react-bootstrap";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import axios from "axios";
import qs from "qs";
import Seo from "@/components/seo/Seo";

const Location = ({ data }) => {
  Fancybox.bind("[data-fancybox]", {
    // Your custom options
    Hash: false,
  });
  const seo = data?.attributes?.seo;

  return (
    <>
      <Seo seo={seo} />

      <section
        id="carouselExampleDark"
        className="carousel carousel-dark slide"
      >
        <div className="carousel-inner">
          <div className="carousel-item active" data-bs-interval="10000">
            <Image
              src={webBanner}
              className="d-none d-md-block  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />
            <Image
              src={mobBanner}
              className="d-block d-md-none  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />
          </div>
        </div>
      </section>
      <section className="sec-padd">
        <Container>
          <div className="inner_text text-center">
            <Row className="justify-content-center">
              <Col md={8}>
                <p className="mb-0">
                  Experience three-way connectivity—road, rail and river.
                  There’s also a 4-way connectivity on the cards with access to
                  the Dakshineshwar metro. What’s more, while the rest of the
                  world will commute on wheels, the residents of new Kolkata
                  will have their very own private jetty, ready to ferry them to
                  their preferred destinations. The ferries will ply tirelessly
                  from New Kolkata and Serampore to Millennium park and
                  Dakshineshwar.
                </p>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <section className="main-section location-section water_mark sec-padd-bot">
        <div className="container">
          <div className="map-section">
            <div className="map-bx">
              <iframe
                allowFullScreen=""
                frameBorder="0"
                src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d14718.989985117858!2d88.34298081502403!3d22.737624761567233!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s449%2FA%2F2%2CG.T.Road%2CMahesh%2CSerampore%2C+Hooghly%2CWest+Bengal+!5e0!3m2!1sen!2sin!4v1516892589980"
              ></iframe>
              <div className="location-box">
                <h2 className="heading02 text-white">Project/Site Address:</h2>
                <p>
                  Alcove Developers LLP
                  <br />
                  New Kolkata,449/A/2,
                  <br />
                  G.T.Road,Mahesh,Serampore, Hooghly,West Bengal
                </p>
              </div>
            </div>
          </div>
          <div className="mt-30">
            <Row>
              <Col md={6}>
                <div className="location_wrapper">
                  <div className="map-box">
                    <div className="add_wrap">
                      <h4 className="loc_title">
                        <strong>Educational Institutions:</strong>
                      </h4>
                      <ul className="accord_list list-unstyled mt-2">
                        <li>Serampore College 1.85 kms.</li>
                        <li>
                          Government College of Engineering & Textile School 1.8
                          kms.
                        </li>
                        <li>Mahesh Sri Ramkrishna Ashram Vidyalaya 1.43kms.</li>
                        <li>DPS North 13.1 Kms.</li>
                      </ul>
                    </div>
                  </div>
                  <div className="map-box">
                    <div className="add_wrap">
                      <h4 className="loc_title">
                        <strong>Business Centers :</strong>
                      </h4>
                      <ul className="accord_list list-unstyled mt-2">
                        <li>Serampore Court 2 Kms.</li>
                        <li>Howrah Maidan 21 Kms.</li>
                        <li>Park Street 25 Kms.</li>
                        <li>Newtown CBD 30 kms.</li>
                      </ul>
                    </div>
                  </div>
                  <div className="map-box">
                    <div className="add_wrap">
                      <h4 className="loc_title">
                        <strong>Entertainment Zones:</strong>
                      </h4>
                      <ul className="accord_list list-unstyled mt-2">
                        <li>Serampore Big Bazar 600 mtr.</li>
                        <li>Forum Rangoli 13.6 kms.</li>
                        <li>City Center II 25.7 kms.</li>
                        <li>New Kolkata Plaza (on site).</li>
                      </ul>
                    </div>
                  </div>
                  <div className="map-box">
                    <div className="add_wrap">
                      <h4 className="loc_title">
                        <strong>Health Care Facilities:</strong>
                      </h4>
                      <ul className="accord_list list-unstyled mt-2">
                        <li>Relife Hospital 6.2 kms.</li>
                        <li>Serampore ESI Hospital 3.1 Kms.</li>
                        <li>Disha Eye Hospital 5.6 Kms.</li>
                      </ul>
                    </div>
                  </div>
                  <div className="map-box">
                    <div className="add_wrap">
                      <h4 className="loc_title">
                        <strong>Major Transportation Connectivity:</strong>
                      </h4>
                      <ul className="accord_list list-unstyled mt-2">
                        <li>Dakshneswar Metro 13.9 kms.</li>
                        <li>Serampore Railway Station 2.5 kms.</li>
                        <li>NSC Bose International Airport 24 kms.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <div className="img-wrap image-container gall_wrp p-0 pe-md-4">
                  <div
                    data-fancybox="map"
                    data-src="/images/location_map.jpg"
                    className="img_overlay"
                  >
                    <Image
                      fill
                      src="/images/location_map.jpg"
                      alt="interior"
                      className="image"
                    />
                    <div className="gall_over"></div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </section>
    </>
  );
};

export default Location;
export async function getServerSideProps() {
  try {
    const query = {
      populate: ["*", "seo", "seo.metaImage", "seo.schema"],
    };

    /** If we are loading projects from anywhere other than the home page, then we load the configuration information also. */

    const queryString = qs.stringify(query, {
      encodeValuesOnly: true,
    });

    const endpoint = `${process.env.NEXT_PUBLIC_BACKEND_API_URL}/api/location?${queryString}`;
    // console.log(`Final url: ${endpoint}`);

    const response = await axios.get(endpoint);
    const data = response.data.data;
    // Pass data to the page via props
    return {
      props: { data },
    };
  } catch (error) {
    console.log("Error", error);
  }
}
